import { FormBase } from 'core/components';

export default class CalendarEventEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'accountRepId',
                    label: 'SCHEDULE.CALENDAR.EDIT.ACCOUNT_REP_LABEL',
                    placeholder: 'SCHEDULE.CALENDAR.EDIT.ACCOUNT_REP_PLACEHOLDER'
                },
                {
                    name: 'intakeRepId',
                    label: 'FACILITY.EDIT.INTAKE_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.INTAKE_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'payorRepId',
                    label: 'FACILITY.EDIT.PAYOR_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.PAYOR_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'documentRepId',
                    label: 'FACILITY.EDIT.DOCUMENT_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.DOCUMENT_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'billingRepId',
                    label: 'FACILITY.EDIT.BILLING_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.BILLING_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'assigneeId',
                    label: 'Assignee',
                    placeholder: 'Select Assignee',
                    rules: 'string'
                },
                {
                    name: 'intakeNote',
                    placeholder: 'FACILITY.EDIT.INTAKE_NOTE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'payorNote',
                    placeholder: 'FACILITY.EDIT.PAYOR_NOTE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'documentNote',
                    placeholder: 'FACILITY.EDIT.DOCUMENT_NOTE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'billingNote',
                    placeholder: 'FACILITY.EDIT.BILLING_NOTE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'notes',
                    label: 'SCHEDULE.CALENDAR.EDIT.NOTES_LABEL',
                    placeholder: 'SCHEDULE.CALENDAR.EDIT.NOTES_PLACEHOLDER'
                },
                {
                    name: 'date',
                    label: 'SCHEDULE.CALENDAR.EDIT.DATE_LABEL',
                    placeholder: 'SCHEDULE.CALENDAR.EDIT.DATE_PLACEHOLDER'
                },
                {
                    name: 'isDoneDocument',
                    type: 'boolean',
                    default: false,
                    label: 'Clinical Review'
                },
                {
                    name: 'isDonePayor',
                    type: 'boolean',
                    default: false,
                    label: 'Insurance Review'
                },
                {
                    name: 'isDoneIntake',
                    type: 'boolean',
                    default: false,
                    label: 'Intake'
                },
                {
                    name: 'isDoneBiller',
                    type: 'boolean',
                    default: false,
                    label: 'Billing'
                },
                {
                    name: 'sendOrder',
                    type: 'boolean',
                    default: false,
                    label: 'Send Order'
                },
                {
                    name: 'productInfoNeeded',
                    type: 'boolean',
                    default: false,
                    label: 'Product Info Needed'
                },
                {
                    name: 'isInventoryDone',
                    type: 'boolean',
                    default: false,
                    label: 'Inventory'
                },
                {
                    name: 'isSecondCheckDone',
                    type: 'boolean',
                    default: false,
                    label: '2nd Payor Check'
                },
                {
                    name: 'isDone',
                    type: 'booleanean',
                    value: false,
                    label: 'Is Done'
                },
                {
                    name: 'noSupply',
                    type: 'boolean',
                    value: false,
                    label: 'No Patients To Supply'
                },
                {
                    name: 'isReminderIntake',
                    type: 'boolean',
                    default: false,
                },
                {
                    name: 'isReminderBiller',
                    type: 'boolean',
                    default: false
                },
                {
                    name: 'isReminderPayor',
                    type: 'boolean',
                    default: false
                },
                {
                    name: 'isReminderDocument',
                    type: 'boolean',
                    default: false
                },
                {
                    name: 'missingInventoryCount',
                    type: 'boolean',
                    default: false,
                    value: false,
                    label: 'Missing Inventory Count'
                },
                {
                    name: 'orderingDetailNote',
                    label: 'DASHBOARD.EDIT_ORDER.ORDERING_DETAIL_NOTE_LABEL',
                    placeholder: 'DASHBOARD.EDIT_ORDER.ORDERING_DETAIL_NOTE_PLACEHOLDER',
                    type: 'textarea',
                    rules: 'string'
                },{
                    name: 'isOrderDone',
                    label: 'DASHBOARD.EDIT_ORDER.IS_ORDER_LABEL',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'backorderNote',
                    label: 'DASHBOARD.EDIT_ORDER.BACKORDER_NOTE_LABEL',
                    placeholder: 'DASHBOARD.EDIT_ORDER.BACKORDER_NOTE_PLACEHOLDER',
                    type: 'textarea',
                    rules: 'string'
                },
                {
                    name: 'deliveryNotes',
                    label: 'SCHEDULE.CALENDAR.EDIT.DELIVERY_NOTES_LABEL',
                    placeholder: 'SCHEDULE.CALENDAR.EDIT.DELIVERY_NOTES_PLACEHOLDER'
                }
            ],
        };
    }
}
